import { useState, useEffect } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import api from '../services/api';

const navPages = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/services', label: 'Services' },
  { path: '/blood-test', label: 'Pathology & Imaging' },
  { path: '/media', label: 'Media Center' },
  { path: '/donate', label: 'Donate' },
  { path: '/contact', label: 'Contact Us' },
];

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [settings, setSettings] = useState({
    phone: '+91 965439 1410 / +91 63933 80889',
    email: 'info@megahealthgroup.org',
    address: 'Head Office: F19, First Floor Ved Vihar Ghaziabad, Uttar Pradesh, INDIA',
    whatsapp: 'https://wa.me/919654391410',
    hours: '24x7',
    facebookUrl: 'https://facebook.com/megahealthgroup',
    instagramUrl: 'https://instagram.com/megahealthgroup',
    youtubeUrl: 'https://youtube.com/megahealthgroup',
  });

  useEffect(() => {
    async function loadSettings() {
      try {
        const response = await api.get('/settings');
        if (response.data) {
          setSettings(response.data);
        }
      } catch (error) {
        console.warn('Failed to load settings from server, using defaults.', error);
      }
    }
    loadSettings();
  }, []);

  return (
    <div>
      {/* Topbar */}
      <div className="topbar">
        <div className="container">
          <div className="topbar-left">
            <a href={`tel:${settings.phone.replace(/\s+/g, '')}`}>
              <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 6, display: 'inline-block', verticalAlign: 'middle' }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              {settings.phone}
            </a>
            <a href={`mailto:${settings.email}`}>
              <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 6, display: 'inline-block', verticalAlign: 'middle' }}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></svg>
              {settings.email}
            </a>
            <span>
              <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 6, display: 'inline-block', verticalAlign: 'middle' }}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              {settings.hours}
            </span>
          </div>
          <div className="topbar-right">
            <a href={settings.facebookUrl} target="_blank" rel="noreferrer">FB</a>
            <a href={settings.instagramUrl} target="_blank" rel="noreferrer">IG</a>
            <a href={settings.youtubeUrl} target="_blank" rel="noreferrer">YT</a>
          </div>
        </div>
      </div>

      {/* Main Header / Navbar */}
      <header className="navbar">
        <div className="container navbar-inner">
          <Link to="/" className="site-brand">
            <img src="/images/logo.png" alt="Mega Health Group Logo" className="site-brand-logo" />
            <div className="site-brand-copy">
              <div className="site-brand-name">
                Mega Health Group
              </div>
              <div className="site-brand-subtitle">
                Excellence in Care
              </div>
            </div>
          </Link>

          <nav className={`navbar-links ${menuOpen ? 'open' : ''}`}>
            {navPages.map(page => (
              <NavLink
                key={page.path}
                to={page.path}
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                onClick={() => setMenuOpen(false)}
              >
                {page.label}
              </NavLink>
            ))}
            <div className="mobile-only-cta">
              <Link to="/contact" className="btn btn-primary" onClick={() => setMenuOpen(false)}>Book Appointment</Link>
              <a href={`tel:${settings.phone.replace(/\\s+/g, '')}`} className="btn btn-outline" style={{ textAlign: 'center' }} onClick={() => setMenuOpen(false)}>Call Us Now</a>
            </div>
          </nav>

          <div className="navbar-actions">
            <Link to="/contact" className="btn btn-primary btn-sm nav-cta">Book Appointment</Link>
            <button type="button" className="hamburger" aria-label="Toggle menu" onClick={() => setMenuOpen(prev => !prev)}>
              ☰
            </button>
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main>
        <Outlet context={{ settings }} />
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                <img src="/images/logo.png" alt="Mega Health Group Logo" style={{ width: 44, height: 44, borderRadius: 12, objectFit: 'cover' }} />
                <div>
                  <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.15rem', color: 'white', fontWeight: 700 }}>Mega Health Group</div>
                  <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Excellence in Care</div>
                </div>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.92rem', marginBottom: 20 }}>
                Providing compassionate, high-quality, and ethical healthcare to our community.<br /><br />
                We accept all major Government Health Insurance schemes as well as Private Health Insurance plans.
              </p>
              <div className="footer-social">
                <a href={settings.facebookUrl} target="_blank" rel="noreferrer" className="social-btn">f</a>
                <a href={settings.instagramUrl} target="_blank" rel="noreferrer" className="social-btn">in</a>
                <a href={settings.youtubeUrl} target="_blank" rel="noreferrer" className="social-btn">▶</a>
              </div>
            </div>
            
            <div className="footer-col">
              <h3>Quick Links</h3>
              <ul>
                {navPages.map(page => (
                  <li key={page.path}>
                    <NavLink to={page.path}>{page.label}</NavLink>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="footer-col">
              <h3>Our Services</h3>
              <ul>
                <li><NavLink to="/services#eye-care">Eye Care</NavLink></li>
                <li><NavLink to="/services#maternity">Maternity Care</NavLink></li>
                <li><NavLink to="/services#pediatrician">Pediatrician</NavLink></li>
                <li><NavLink to="/services#cosmetic-gynae">Cosmetic Gynecology</NavLink></li>
                <li><NavLink to="/services#ent">ENT Care</NavLink></li>
                <li><NavLink to="/services#dental">Dental Services</NavLink></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h3>Contact Info</h3>
              <ul>
                <li>
                  <a href={`tel:${settings.phone.replace(/\s+/g, '')}`} style={{ display: 'flex', alignItems: 'center' }}>
                    <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                    {settings.phone}
                  </a>
                </li>
                <li>
                  <a href={`mailto:${settings.email}`} style={{ display: 'flex', alignItems: 'center' }}>
                    <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></svg>
                    {settings.email}
                  </a>
                </li>
                <li style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.92rem', display: 'flex', alignItems: 'center' }}>
                  <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  {settings.address}
                </li>
                <li style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.92rem', display: 'flex', alignItems: 'center' }}>
                  <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  {settings.hours}
                </li>
              </ul>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>© 2026 Mega Health Group. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</Link>
              <Link to="/terms" style={{ color: 'inherit', textDecoration: 'none' }}>Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Chat widget */}
      <a href={settings.whatsapp} className="whatsapp-float" target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp">
        <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </div>
  );
}

export default Layout;
